import React from "react";
import { Card, Divider } from "antd";
import { ClipboardCheck, Calendar } from "lucide-react";

export default function WorkStatusGrid({ workStats, requesting }) {

const formatMinutes = (mins) => {
  if (mins == null) return "-"; 
  return Number(mins) % 1 === 0 ? Number(mins) : Number(mins).toFixed(2);
};

  const workStatsData = [
    {
      id: 1,
      label: "Total Work Hours",
      value: `${workStats?.totalWorkHours} hrs`,
      details: [
        { name: "Regular Hours", value: `${workStats?.regularHours} hr/s` },
        { name: "Overtime", value: `${workStats?.overtimeHours} hr/s`, color: "text-blue-600 dark:text-blue-400" },
      ],
      icon: <ClipboardCheck className="w-5 h-5" />,
      textColor: "text-green-600 dark:text-green-500",
    },
    {
      id: 2,
      label: "Lunch Breaks",
      value: "-",
      details: [
        { name: "Total Breaks", value: "—" },
        { name: "Avg. Duration", value: "—" },
      ],
      icon: <Calendar className="w-5 h-5" />,
      textColor: "text-amber-600 dark:text-amber-500",
    },
    {
      id: 3,
      label: "Total Late/Undertime",
      value: `${formatMinutes(workStats?.tardiness.totalMinutes)} mins`,
      details: [
        { 
          name: "Late Days", 
          value: `${workStats?.tardiness.lateDays}/${workStats?.workdaysScheduled}` 
        },
        { 
          name: "Max Delay", 
          value: `${formatMinutes(workStats?.tardiness.maxDelayMinutes)} mins` 
        },
      ],
      icon: <ClipboardCheck className="w-5 h-5" />,
      textColor: "text-red-500 dark:text-red-400",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10 px-1">
      {workStatsData.map((item) => (
        <Card
          key={item.id}
          className="flex flex-col gap-6 rounded-xl border border-slate-200 dark-mode-card dark:border-slate-800"
          bodyStyle={{ padding: 16 }}
        >
          <div className="flex items-center gap-3 mb-3">
            <div className={`p-2 bg-text ${item.label.toLowerCase().replace(/[ /]+/g, "-")}`}>{item.icon}</div>
            <div>
              <p className="text-xs dark:text-white">{item.label}</p>
              <p className={`text-lg font-bold ${item.textColor}`}>
                {requesting ? "Loading..." : item.value}
              </p>
            </div>
          </div>

          <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

          <div className="space-y-1 text-xs">
            {item.details.map((d, i) => (
              <div key={i} className="flex justify-between dark:text-white">
                <span>{d.name}:</span>
                <span className={`font-semibold ${d.color ?? ""}`}>{d.value}</span>
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
}
